import React from "react";

const PrintJson = ({ data }) => {
  return (
    // <>
    
    // </>
    <details className=" border rounded-lg">
      <summary className="p-4 cursor-pointer font-medium">
        📋 Raw API Response (Click to expand)
      </summary>
      <pre className=" p-4 rounded-md text-xs overflow-auto max-h-96">
        {JSON.stringify(data, null, 2)}
      </pre>
    </details>
  );
};

export default PrintJson;
